export interface Bonus {
  tag: string
  title: string
  description: string
  image: string
  imageAlt: string
  value: string
  featured?: boolean
}

export const bonuses: Bonus[] = [
  {
    tag: 'Bonus 01',
    title: 'Mapa Bagua Visual + Plantilla para tu Hogar',
    description:
      'Una guía visual de las 9 áreas del Bagua con una plantilla para superponer sobre el plano de tu casa y comenzar a analizarla área por área.',
    image: 'https://cdn.magicpatterns.com/uploads/pgnLMPZoXoBLvvDCiLgp7F/mapa_bagua.webp',
    imageAlt: 'Mapa Bagua visual con las nueve áreas del hogar y plantilla para el plano',
    value: 'USD 20',
    featured: true,
  },
  {
    tag: 'Bonus 02',
    title: 'Guía de Activación de las 9 Áreas del Bagua',
    description:
      'Descubrí qué representa cada sector de tu hogar y aprendé cómo trabajarlo con colores, elementos, objetos, distribución y pequeños cambios intencionales.',
    image: 'https://cdn.magicpatterns.com/uploads/ft6N3gvo7sFRi5MUDwmXcS/activacion_9_areas.png',
    imageAlt: 'Portada de la Guía de Activación de las 9 Áreas del Bagua',
    value: 'USD 10',
  },
  {
    tag: 'Bonus 03',
    title: 'Mi Casa, Mi Energía',
    description:
      'Cuaderno práctico para registrar tu diagnóstico, los cambios que vas realizando y cómo se siente cada ambiente después.',
    image: 'https://cdn.magicpatterns.com/uploads/pCiqkPEeQoW1sqX6khpqBp/mi_casa_mi_energia.webp',
    imageAlt: 'Portada del cuaderno práctico Mi Casa, Mi Energía',
    value: 'USD 10',
  },
  {
    tag: 'Bonus 04',
    title: '50 Cambios de Feng Shui sin Gastar Dinero',
    description:
      'Cincuenta acciones concretas para aplicar hoy mismo utilizando los muebles, objetos y espacios que ya tenés en casa.',
    image: 'https://cdn.magicpatterns.com/uploads/t36tFvKjtdkCyBEPb7fCnM/50_cambios_de_feng_shui.webp',
    imageAlt: 'Portada del bonus 50 Cambios de Feng Shui sin Gastar Dinero',
    value: 'USD 10',
  },
  {
    tag: 'Bonus 05',
    title: 'Póster Mapa Bagua imprimible',
    description:
      'Las 9 áreas con su elemento, colores y palabras clave en una sola hoja lista para imprimir y tener siempre a mano.',
    image: 'https://cdn.magicpatterns.com/uploads/wm3gp8M2g92167w9tLBWe4/plantilla_imprimible.webp',
    imageAlt: 'Póster imprimible del Mapa Bagua',
    value: 'USD 10',
  },
]

export const bonusesTotalValue = 'USD 60'

export interface NextStep {
  title: string
  paragraphs: string[]
  note: string
  image: string
  imageAlt: string
}

export const nextSteps: NextStep[] = [
  {
    title: 'Feng Shui de la Abundancia',
    paragraphs: [
      'Una guía especializada para trabajar prosperidad, crecimiento y oportunidades desde tu hogar. Profundiza en la entrada, cocina, escritorio, área de prosperidad, elementos Agua y Madera, plantas, iluminación y organización.',
      'Incluye recomendaciones para profesionales y emprendedoras, checklist de abundancia y un plan práctico de 7 días.',
    ],
    note: 'Disponible como guía especializada después de tu compra.',
    image: 'https://cdn.magicpatterns.com/uploads/phypGL2YDyaaXfCrRA6EWn/feng_shui_de_la_abundancia.webp',
    imageAlt: 'Portada de la guía Feng Shui de la Abundancia',
  },
  {
    title: 'Feng Shui para el Amor',
    paragraphs: [
      'Profundizá en el área del amor, el dormitorio, la posición de la cama, simetría, colores, iluminación, fotografías, objetos en pares, arte y distribución del espacio.',
      'Incluye recomendaciones para personas solteras y parejas, checklist de relaciones y un plan de renovación del dormitorio.',
    ],
    note: 'Disponible como guía especializada después de tu compra.',
    image: 'https://cdn.magicpatterns.com/uploads/tPRCUTw8q2WNwePjDRjKnk/feng_shui_del_amor.webp',
    imageAlt: 'Portada de la guía Feng Shui para el Amor',
  },
]
